import { DictationOrigin } from '@highlight/common'
import { useGlobalState } from '@highlight/ipc/react'
import { useCallback, useEffect } from 'react'

export const useDictatedText = (origin: DictationOrigin) => {
  const [dictatedText, setDictatedText] = useGlobalState<string>(origin + '.dictation', '')

  const clearDictatedText = useCallback(() => {
    setDictatedText('')
  }, [setDictatedText])

  return { dictatedText, clearDictatedText }
}
